// src/components/Layout.jsx
import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { supabase } from '../lib/supabase';

const Icons = {
  dashboard:      () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>,
  leads:          () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  casos:          () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1"/><line x1="8" y1="11" x2="16" y2="11"/><line x1="8" y1="15" x2="16" y2="15"/></svg>,
  prazos:         () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="13" r="8"/><polyline points="12 9 12 13 15 15"/><path d="M9 1h6"/></svg>,
  conteudo:       () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/><circle cx="9" cy="15" r="1.5"/><circle cx="15" cy="15" r="1.5"/></svg>,
  agenda:         () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
  crm:            () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="3" width="5" height="18" rx="1"/><rect x="10" y="7" width="5" height="14" rx="1"/><rect x="17" y="11" width="5" height="10" rx="1"/></svg>,
  projetos:       () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/></svg>,
  metas:          () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>,
  financeiro:     () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
  relatorios:     () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>,
  colaboradores:  () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>,
  config:         () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>,
  playbook:       () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>,
  areaCliente:    () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-6 8-6s8 2 8 6"/><circle cx="19" cy="6" r="2.4" fill="currentColor" stroke="none"/></svg>,
  logout:         () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>,
  bell:           () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>,
  plus:           () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
};

function getNavItens(perfil, acesso) {
  const todos = [
    { path: '/',              label: 'Central do Dia', icon: 'dashboard',    secao: 'Principal', key: 'dashboard' },
    { path: '/leads',         label: 'Leads',          icon: 'leads',        secao: 'Principal', key: 'leads' },
    { path: '/crm',           label: 'CRM',            icon: 'crm',          secao: 'Principal', key: 'crm' },
    { path: '/agenda',        label: 'Agenda',         icon: 'agenda',       secao: 'Principal', key: 'agenda' },
    { path: '/projetos',      label: 'Projetos',       icon: 'projetos',     secao: 'Gestão',    key: 'projetos' },
    { path: '/casos',         label: 'Casos',          icon: 'casos',        secao: 'Gestão',    key: 'casos' },
    { path: '/prazos',        label: 'Prazos',         icon: 'prazos',       secao: 'Gestão',    key: 'prazos' },
    { path: '/conteudo',      label: 'Conteúdo',       icon: 'conteudo',     secao: 'Gestão',    key: 'conteudo' },
    { path: '/metas',         label: 'Metas',          icon: 'metas',        secao: 'Gestão',    key: 'metas' },
    { path: '/financeiro',    label: 'Financeiro',     icon: 'financeiro',   secao: 'Gestão',    key: 'financeiro' },
    { path: '/relatorios',    label: 'Relatórios',     icon: 'relatorios',   secao: 'Gestão',    key: 'relatorios' },
    { path: '/area-cliente',  label: 'Área do Cliente',icon: 'areaCliente',  secao: 'Gestão',    key: 'area-cliente' },
    { path: '/playbook',      label: 'Playbook',       icon: 'playbook',     secao: 'Principal', key: 'playbook' },
    { path: '/colaboradores', label: 'Colaboradores',  icon: 'colaboradores',secao: 'Admin',     key: 'colaboradores', somente: ['admin'] },
    { path: '/configuracoes', label: 'Configurações',  icon: 'config',       secao: 'Admin',     key: 'configuracoes', somente: ['admin'] },
  ];

  return todos.filter(item => {
    // Somente admin vê itens de Admin (colaboradores, configurações)
    if (item.somente && !item.somente.includes(perfil)) return false;
    // Admin e gestor veem tudo (exceto restrições acima)
    if (perfil === 'admin' || perfil === 'gestor') return true;
    // Todos os outros cargos (adm, sdr, closer, saude, infoprodutos) respeitam o campo acesso
    if (acesso && typeof acesso === 'object') return !!acesso[item.key];
    // Fallback sem acesso configurado
    return ['dashboard','leads','crm','agenda','metas','playbook'].includes(item.key);
  });
}

function iniciais(nome = '') {
  return nome.split(' ').map(p => p[0]).slice(0, 2).join('').toUpperCase();
}

export default function Layout() {
  const { usuario, logout } = useAuth();
  const location = useLocation();

  const TITULOS = {
    '/':              'Central do Dia',
    '/leads':         'Leads',
    '/crm':           'CRM',
    '/agenda':        'Agenda',
    '/projetos':      'Projetos',
    '/casos':         'Casos',
    '/prazos':        'Painel de Prazos',
    '/conteudo':      'Calendário de Conteúdo',
    '/metas':         'Metas',
    '/financeiro':    'Financeiro',
    '/relatorios':    'Relatórios',
    '/colaboradores': 'Colaboradores',
    '/configuracoes': 'Configurações',
    '/playbook':      'Playbook',
    '/area-cliente':  'Área do Cliente',
  };

  const tituloPagina = TITULOS[location.pathname] || 'Central do Dia';
  const [notifAberta, setNotifAberta] = useState(false);
  const [toasts, setToasts] = useState([]);
  const nomesProjetosRef = useRef({});

  useEffect(() => {
    supabase.from('projetos').select('id, nome').then(({ data }) => {
      if (data) nomesProjetosRef.current = Object.fromEntries(data.map(p => [p.id, p.nome]));
    });

    const canal = supabase
      .channel('portal_acessos_layout')
      .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'portal_acessos' }, (payload) => {
        const projetoId = payload.new.projeto_id;
        const nome = nomesProjetosRef.current[projetoId] || 'Um projeto';
        const id = payload.new.id;
        setToasts(t => [...t, { id, texto: `🔔 ${nome} acabou de abrir o portal do cliente` }]);
        setTimeout(() => setToasts(t => t.filter(x => x.id !== id)), 7000);
      })
      .subscribe();

    const canalRoteiros = supabase
      .channel('roteiro_eventos_layout')
      .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'roteiro_eventos', filter: 'etapa=eq.enviado_edicao' }, async (payload) => {
        const projetoId = payload.new.projeto_id;
        const nome = nomesProjetosRef.current[projetoId] || 'Um projeto';
        const id = payload.new.id;
        const { data: conteudo } = await supabase.from('conteudos').select('titulo').eq('id', payload.new.conteudo_id).single();
        const titulo = conteudo?.titulo ? ` — "${conteudo.titulo}"` : '';
        setToasts(t => [...t, { id, texto: `🎬 ${nome} enviou um vídeo pra edição${titulo}` }]);
        setTimeout(() => setToasts(t => t.filter(x => x.id !== id)), 9000);
      })
      .subscribe();

    return () => { supabase.removeChannel(canal); supabase.removeChannel(canalRoteiros); };
  }, []);

  const navItens = getNavItens(usuario?.perfil || 'sdr', usuario?.acesso);
  const secoes = [...new Set(navItens.map(i => i.secao))];

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <div className="logo-mark"><span className="logo-v">V</span></div>
          <div className="logo-text"><strong>VULI GROUP</strong><small>CRM Comercial</small></div>
        </div>

        <nav className="sidebar-nav">
          {secoes.map(secao => (
            <div key={secao}>
              <div className="nav-section">{secao}</div>
              {navItens.filter(item => item.secao === secao).map(item => {
                const Icon = Icons[item.icon];
                return (
                  <NavLink key={item.path} to={item.path} end={item.path === '/'}
                    className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
                    <span className="nav-icon" style={{ width:16, height:16, display:'inline-block' }}>
                      {Icon && <Icon />}
                    </span>
                    {item.label}
                  </NavLink>
                );
              })}
            </div>
          ))}
        </nav>

        <div className="sidebar-user">
          <div className="user-avatar" style={{ overflow:'hidden', padding:0, display:'flex', alignItems:'center', justifyContent:'center' }}>
            {usuario?.foto_url
              ? <img src={usuario.foto_url} alt={usuario?.nome} style={{ width:'100%', height:'100%', objectFit:'cover', borderRadius:'50%' }} />
              : iniciais(usuario?.nome)}
          </div>
          <div style={{ flex:1, minWidth:0 }}>
            <div className="user-name" style={{ overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{usuario?.nome}</div>
            <div className="user-role">{usuario?.perfil}</div>
          </div>
          <button onClick={logout} className="btn-logout" title="Sair do CRM">
            <span style={{ width:16, height:16, display:'inline-block' }}><Icons.logout /></span>
          </button>
        </div>
      </aside>

      <div className="main-area">
        <header className="topbar">
          <div className="topbar-title">{tituloPagina}</div>
        </header>
        <main className="content">
          <Outlet />
        </main>
      </div>

      <div style={{ position:'fixed', top:16, right:16, zIndex:3000, display:'flex', flexDirection:'column', gap:8, maxWidth:320 }}>
        {toasts.map(t => (
          <div key={t.id} onClick={() => setToasts(ts => ts.filter(x => x.id !== t.id))}
            style={{ background:'linear-gradient(135deg,#3F0051,#7B2FBE)', color:'white', padding:'12px 16px', borderRadius:12, fontSize:13, fontWeight:600, boxShadow:'0 8px 24px rgba(63,0,81,0.35)', cursor:'pointer' }}>
            {t.texto}
          </div>
        ))}
      </div>
    </div>
  );
}
